import { Authorizer } from "@styleguide";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const ExportsDashboard = lazy(() => import("./Dashboard"));
const ErrorPage = lazy(() => import("@root/error"));

export const exportsRoutes = [
  {
    path: "/v2/settings/exports",
    element: (
      <Authorizer
        requiredPermissions={["settings.exports.visualize"]}
        Authorized={ExportsDashboard}
        redirect="/v2/candidates/dashboard"
      />
    ),
    errorElement: <ErrorPage />,
  },
] as const satisfies RouteObject[];
